import moment from "moment";

const formatTimeNumber = (date: any) => {
  return moment(date).format("HH:mm:ss");
};
export default formatTimeNumber;
